import { CartUrl, CartFeeSummaryUrl, APIDownError } from "../directives/utilities/urls";
export default function gradeOptionDiscount() {
// Revision History
// 2024-11-08 TBH - Clear discount codes after getting cart items.
// console.log( 'gradeOptionDiscount()' );
  return {
    coursePreRequisitesListData: [],
    removedCoursesList:'',
    enrollmentCartList:[],
    byPassPrerequisites: false,
    selectedUciNetOptionSerialId: '',
    selectedAcademicSessionValue:'',
    showErrorMesage: false,
    showLoader: false,
    message: '',
    isSubmitting: false,
    successMessage:'',
    cartUrl: CartUrl,
    bindCartList() {
      var jsonData = JSON.stringify({
        SessionId: "",
        CartRequestType: "A"
      });     
      this.enrollmentCartList = [];
      var jsonDataCartPreviousAddDropWaitCheck = JSON.stringify({
        "RemoveCourses": true    
      });

      fetch("/api/Checkout/CartPreviousAddDropWaitCheck", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: jsonDataCartPreviousAddDropWaitCheck,
      }).then((response) => {
        return response.json();
      }).then((response) => {
        this.showLoader = false;
        if (response != undefined && response.isSuccess) {
          if (response.removedCourses.length > 0) {
            this.removedCoursesList = response.removedCourses.join(", ");
          } 
        } 
              
      fetch("/api/Checkout/GetCartWithGradeOptions", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: jsonData,
      }).then((response) => {
        return response.json();
      }).then((response) => {
        this.showLoader = false;
                          
        if (response != undefined && response.isSuccess) {
          if (response.cartItems.length > 0) {
            Array.prototype.push.apply(this.enrollmentCartList, response.cartItems);
            this.enrollmentCartList.forEach(( item ) => item.discountCode = "" );
          } else {
            this.showErrorMesage = "Your cart is empty.";
          }
        }
      });
    });
  },
    nextStep(itemList, step) {
    // The 'step' parameter not used.
      var isValidRequest = true;
      if (itemList.length > 0) {
        for (var item = 0; item < itemList.length > 0; item++) {
          if (itemList[item].sectionGradeOption.length > 0 
              &&( itemList[item].selectedGradeOption == null || itemList[item].selectedGradeOption == '')) {
            itemList[item].sectionGradeOptionErrorMessage = "Please select Grade Option";
            isValidRequest = false;
          } else {
            itemList[item].sectionGradeOptionErrorMessage = "";
          }
        } 
        if (!isValidRequest) 
          return false;
        this.isSubmitting = true;
        if (isValidRequest) {
          fetch('/api/Checkout/assess-cart', { 
            "method": "GET" 
          }).then(response => {
            return response.json();
          }).then( login => {
            this.isSubmitting = false;
            if (login.isSuccess) {  
              document.location.href = CartFeeSummaryUrl;
            } else {
              this.successMessage = APIDownError;
            }
          })
        }
      } 
    },
    init() {
      this.coursePreRequisitesListData= [],
      this.bindCartList();           
    },
    OnChangeGradeOption(selectedValue,item) {
      if (selectedValue != null && selectedValue.length > 0) {
        var jsonDate = JSON.stringify({
          "AcademicYear": item.academicYear,
          "AcademicTerm": item.academicTerm,
          "AcademicSession": item.academicSession,
          "SerialId": item.serialId,
          "SessionId": item.serialId,
          "GradeOption": selectedValue,
        });
        fetch("/api/Checkout/SaveGradeOption", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: jsonDate
        }).then((response) => {
          return response.json();
        }).then((response) => {
          this.showLoader = false;
          if (response != undefined && response.isSuccess) {
            item.sectionGradeOptionErrorMessage = "";
          } else {
            /* NOP */
          }
        });
      }
    },
    ValidateDiscountCode(item) {      
      if (item.discountCode != null && item.discountCode.length > 0) {
        var jsonDate = JSON.stringify({
          "AcademicYear": item.academicYear,
          "AcademicTerm": item.academicTerm,
          "AcademicSession": item.academicSession,
          "SerialId": item.serialId,
          "SessionId": item.serialId,
          "DiscountCode": item.discountCode
        });  
        fetch("/api/Checkout/apply-discount", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: jsonDate
        }).then((response) => {
          return response.json();
        }).then((response) => {
          this.showLoader = false;
          if (response != undefined && response.isSuccess) {
            item.discountCodeErrorMessage = !response.isValidDiscountCode 
                ? "Discount code " + item.discountCode + " not valid" 
                : "";
            item.discountCode = response.isValidDiscountCode ? item.discountCode : "";
          }
        });
      }
    }
  }
}